export default {
  install: (Vue: any) => {

    Vue.cursorMove = (event: any) => {
      const mouse1 = document.getElementById('cursor-main');
      const mouse2 = document.getElementById('cursor-follower');
      mouse1!.style.top = event.clientY + 'px';
      mouse1!.style.left = event.clientX + 'px';
      setTimeout(() => {
        mouse2!.style.left = event.clientX + 'px';
        mouse2!.style.top = event.clientY + 'px';
      }, 100);
    };

    Vue.mixin({
      methods: {
        showClose() {
          document.getElementById('custom-cursor')!.classList.add('close');
        },
        hideClose() {
          document.getElementById('custom-cursor')!.classList.remove('close');
        },
        showMore() {
          document.getElementById('custom-cursor')!.classList.add('more');
        },
        hideMore() {
          document.getElementById('custom-cursor')!.classList.remove('more');
        },
        onMouseOver() {
          document.getElementById('custom-cursor')!.classList.add('state-hover');
        },
        onMouseOut() {
          document.getElementById('custom-cursor')!.classList.remove('state-hover');
        },
      },
      created: () => {
        window.addEventListener('mousemove', Vue.cursorMove);
      },
      destroyed() {
        window.removeEventListener('mousemove', Vue.cursorMove);
      },
    });

  },
};
